import React, { useEffect, useRef, useCallback } from "react";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import { Link } from "react-router-dom";
import withRouter from "Components/withRouter";
import {DATA_ADMIN, DATA_MANAGER} from './data'
import { useSelector } from "react-redux";
import { selectUserType } from "slices/current user/reducer";

const SidebarContent = (props: any) => {
  const ref = useRef<any>();
  const user_type = useSelector(selectUserType); 
  const DATA = user_type === 'Admin' ? DATA_ADMIN : DATA_MANAGER;

  const activateParentDropdown = useCallback((item: any) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = window.location.origin + window.location.pathname;
    // console.log('pathName', pathName);
    // console.log('window.location', window.location);
    // console.log('window.location.pathname', window.location.pathname);
    let matchingMenuItem = null;
    const ul: any = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].href) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [props.router.location.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item: any) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

// const handleLiClick = (e: React.MouseEvent<HTMLLIElement>) => {
//     if (window.innerWidth <= 990) {
//       document.body.classList.remove("sidebar-enable");
//     }
//   }
function openChildItems() {
  var body = document.body;
  // body.classList.remove("vertical-collpsed");
  body.classList.remove("sidebar-enable");
}

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {/* <li className="menu-title">Menu</li> */}

            {DATA.map((item: any) => {
              return (
                <li key={item.key}>
                  {(item.title) ? <span className="menu-title">{item.title}</span> : ""}
                  {(item.children && item.children.length > 0) ? (
                  <>
                    <a className="has-arrow">
                      <i className={`bx ${item.icon}`}></i>
                      <span>{item.name}</span>
                    </a>
                    <ul className="sub-menu">
                      {item.children.map((child: any) => {
                        return (
                          <li key={child.key} onClick={() => openChildItems()}>
                            <Link to={child.link}>{child.name}</Link>
                          </li>
                        );
                      })}
                    </ul>
                  </>)
                  :
                  <Link to={item.link}>
                    <i className={`bx ${item.icon}`}></i>
                    <span>{item.name}</span>
                  </Link>
                  }
                </li>
              );
            })}

            {/* <li className="menu-title">Inventory</li> */}
           
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};
export default withRouter((SidebarContent));
